import { Component, OnInit, Input, TemplateRef, ContentChild, Output, EventEmitter, Injector, ElementRef } from '@angular/core';
import { Question } from '../interfaces/question';
import { QuestionsManagerComponent } from '../questions-manager/questions-manager.component';
import { Draft } from '../services/draft.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionnaireService } from '../services/questionnaire.service';

@Component({
	selector: 'question',
	templateUrl: './question.component.html',
	styleUrls: ['./question.component.scss']
})
export class QuestionComponent implements OnInit {
	@Input() qID: string;
	@Output() elemRef:ElementRef;
	isActiveStep1 = false;
	//@Input() state: string;
	//@Input() result: any = null;
	//@Output() resultChange: EventEmitter<any> = new EventEmitter<any>();
	isAfterStep1 =false;
	parentComponent: QuestionsManagerComponent;
	constructor(private inj: Injector, elm:ElementRef,
		private draft: Draft,
		private router: Router,
		private route: ActivatedRoute,
		public questionnaireService: QuestionnaireService,
		) {
		this.route.url.subscribe(params=>{
			this.isAfterStep1 =draft.isAfterStep1;
			console.log(this.router.url)
			if(this.router.url.includes("user-details")){
				this.isActiveStep1 = true;
			}
			else{
				this.isActiveStep1 = false;
			}
		})
		this.parentComponent = this.inj.get(QuestionsManagerComponent);
		this.elemRef=elm;
		//console.log(this.parentComponent);
	}

	ngOnInit() {
		//this.resultChange.emit(1);
		this.parentComponent.addQuestion(this);
	}
	

	edit(qID){
		console.log("edit()");
		this.parentComponent.setEditQuestion(qID);
	}

	save(){
		console.log("save()");	
	}

}



// WEBPACK FOOTER //
// ./src/app/question/question.component.ts